module.exports = __webpack_public_path__ + "img/SpecificationFeatures.e88cf893.png";